import loadable from '@loadable/component';

export const ReportsDetailGraphicConfigurationFilterCustomerSchema = loadable(
  () => import('./ReportsDetailGraphicConfigurationFilterCustomerSchema'),
);
